<template>
    <div class="row">
        <div class="col-12 col-lg-4 col-xl-3 order-lg-2">
            <filter-shops
                :categories="marketCategories"
                :countries="marketCountries"
                :mainlng="mainlng"
                :lng="lng"
                :translations="translations"
                v-on:childToParent="handleFilter($event)"
            ></filter-shops>
        </div>
        <div class="col-12 col-lg-8 col-xl-9 order-lg-1">
            <shop-list :markets="marketList" :mainlng="mainlng" :lng="lng"></shop-list>
            <p v-show="marketList.length < 1">{{ get_translation_constant('text_no_results') }}</p>
            <div class="pagination__block">
                <vue-pagination :data="marketListPagination" :limit="2" @pagination-change-page="getResults"
                                size="small" :show-disabled="false"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Shops",
    props: {
        translations: {
            type: [Object, Array]
        },
        elements: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        shopssearchurl: {
            type: [String]
        },
    },
    data() {
        return {
            on_create_trigger: 0,
            filter_data: {
                params: {},
                current_page: 1,
            },
            marketList: [],
            marketListPagination: [],
            marketCategories: [],
            marketCountries: [],
        }
    },
    methods: {
        prepareFilterParams(data) {
            if (data.params === []) {
                return {
                    marketCategory: [],
                    marketCountry: [],
                    sortBy: data.params.sortBy.search,
                    page: data.current_page,
                    locale :this.locale,
                }
            }
            let filter = {
                marketCategory: (Object.values(data.params.marketCategory).filter((item) => {
                    return item.checked === true
                }).map((item) => {
                    return item.id
                })).join(','),
                marketCountry: (Object.values(data.params.marketCountry).filter((item) => {
                    return item.checked === true
                }).map((item) => {
                    return item.id
                })).join(','),
                sortBy: data.params.sortBy.search,
                page: data.current_page,
                locale :this.locale,
            }
            if (typeof data.params.search !== 'undefined' && data.params.search !== null && data.params.search !== '') {
                filter.search = data.params.search;
            }
            if (typeof data.params.searchChange !== 'undefined' && data.params.searchChange !== null && data.params.searchChange === true ){
                filter.page = 1;
            }
            if (typeof this.filter_data.params.searchChange !== 'undefined' && this.filter_data.params.searchChange !== null && this.filter_data.params.searchChange === true ){
                this.filter_data.params.searchChange = false;
            }
            return filter;
        },
        getResults(page = 1, filter_params = []) {
            this.on_create_trigger++;
            if (this.on_create_trigger == 1) {
                this.filter_data.current_page = page;
                this.filter_data.params = filter_params;
            }
            if (Array.isArray(filter_params)) {
                filter_params = this.filter_data.params;
            }
            if (this.on_create_trigger > 2) {
                this.filter_data.current_page = page;
                this.filter_data.params = filter_params;
                this.asyncFind(this.prepareFilterParams(this.filter_data));
            }
        },
        handleFilter(data) {
            this.marketCategories = data.marketCategory
            this.marketCountries = data.marketCountry
            this.getResults(this.filter_data.current_page, data);
        },
        asyncFind(filter_params) {
            axios.post(this.shopssearchurl, filter_params).then(response => {
                this.marketListPagination = response.data
                this.marketList = response.data.data
            }).catch(error => {
                if (error.response.status === 422) {

                }
                if (error.response.status === 500) {
                    //   this.alert = error.response.data.errors;
                }
            });
        },
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        }
    },
    computed: {},
    mounted() {

    },
    created() {
        this.marketList = this.elements.markets.data
        this.marketListPagination = this.elements.markets
        this.marketCategories = this.elements.marketCategories.map((item) => {
            item.checked = false;
            return item
        })
        this.marketCountries = this.elements.marketCountries.map((item) => {
            item.checked = true;
            return item
        })
    }
}
</script>

<style scoped>

</style>
